import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\CommissionNote\StoreCommissionNoteItemController::__invoke
* @see app/Http/Controllers/CommissionNote/StoreCommissionNoteItemController.php
* @route '/api/commission-note/{commission_note}/items'
*/
const StoreCommissionNoteItemController = (args: { commission_note: string | number | { id: string | number } } | [commission_note: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: StoreCommissionNoteItemController.url(args, options),
    method: 'post',
})

StoreCommissionNoteItemController.definition = {
    methods: ["post"],
    url: '/api/commission-note/{commission_note}/items',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\CommissionNote\StoreCommissionNoteItemController::__invoke
* @see app/Http/Controllers/CommissionNote/StoreCommissionNoteItemController.php
* @route '/api/commission-note/{commission_note}/items'
*/
StoreCommissionNoteItemController.url = (args: { commission_note: string | number | { id: string | number } } | [commission_note: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { commission_note: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { commission_note: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            commission_note: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        commission_note: typeof args.commission_note === 'object'
        ? args.commission_note.id
        : args.commission_note,
    }

    return StoreCommissionNoteItemController.definition.url
            .replace('{commission_note}', parsedArgs.commission_note.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\CommissionNote\StoreCommissionNoteItemController::__invoke
* @see app/Http/Controllers/CommissionNote/StoreCommissionNoteItemController.php
* @route '/api/commission-note/{commission_note}/items'
*/
StoreCommissionNoteItemController.post = (args: { commission_note: string | number | { id: string | number } } | [commission_note: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: StoreCommissionNoteItemController.url(args, options),
    method: 'post',
})

export default StoreCommissionNoteItemController